module.exports = __webpack_public_path__ + "static/media/folder_active.d0d80a9c.svg";